import React from 'react';
import { flowRight as compose } from 'lodash';
import Redirect from '../../components/Redirect';
import RedirectSignIn from '../../components/RedirectSignIn';
import withAuth, { withAuthPropType } from '../../hocs/withAuth';
import withLocaleProvider from '../../hocs/withLocaleProvider';
import withRouting from '../../hocs/withRouting';

/**
 * Sign-in has no form of its own any more - it just decides where to send the visitor: back
 * into the app if already authenticated, or off to whichever login flow is currently active
 * (Zitadel or auth-hub) to start a new session.
 */
function SignIn({ auth }) {
  if (auth.authenticated) {
    return <Redirect route="Dashboard" method="replace" />;
  }

  if (auth.loading) {
    return null;
  }

  return <RedirectSignIn method="replace" />;
}

SignIn.propTypes = {
  auth: withAuthPropType.isRequired,
};

export default compose(
  withLocaleProvider,
  withRouting,
  withAuth()
)(SignIn);
